import { FaArrowDown, FaCertificate, FaGlobeAsia } from 'react-icons/fa';
import Button from './ui/Button';
import './Hero.css';

const STATS = [
  { value: '25+', label: 'Years Experience' },
  { value: '500+', label: 'Products' },
  { value: '40+', label: 'Countries' },
];

export default function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero__overlay" aria-hidden="true" />

      <div className="hero__content container">
        <div className="hero__badge">
          <FaCertificate aria-hidden="true" />
          <span>ISO Certified</span>
          <span className="hero__badge-sep" aria-hidden="true">|</span>
          <FaGlobeAsia aria-hidden="true" />
          <span>Exporting Worldwide</span>
        </div>

        <h1 className="hero__heading">
          Precision Surgical<br />
          <span className="hero__highlight">Instruments</span>
          <span className="hero__origin"> from Pakistan</span>
        </h1>

        <p className="hero__desc">
          H.A Surgical manufactures world-class medical and surgical instruments
          in Sialkot, Pakistan — trusted by hospitals, clinics, and distributors
          across 40+ countries.
        </p>

        <div className="hero__actions">
          <Button href="/#products" variant="primary">Explore Products</Button>
          <Button href="/catalogs" variant="outline">Browse Catalogs</Button>
          <Button href="/#contact" variant="outline">Request a Quote</Button>
        </div>

        <div className="hero__stats">
          {STATS.map((s, i) => (
            <div key={s.label} className="hero__stat-group">
              {i > 0 && <span className="hero__stat-sep" aria-hidden="true" />}
              <div className="hero__stat">
                <span className="hero__stat-num">{s.value}</span>
                <span className="hero__stat-label">{s.label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <a href="#about" className="hero__scroll" aria-label="Scroll to About section">
        <FaArrowDown aria-hidden="true" />
      </a>
    </section>
  );
}
